/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { acceptancesControllerAccept } from "./acceptancesControllerAccept";
import { acceptancesControllerCheckStatus } from "./acceptancesControllerCheckStatus";
import { acceptancesControllerGetAcceptances } from "./acceptancesControllerGetAcceptances";

export function acceptancesService() {
  return { acceptancesControllerGetAcceptances, acceptancesControllerCheckStatus, acceptancesControllerAccept }
}